<template>
  <div>
    <div class="d-flex justify-end sticky to-header">
      <v-btn
        v-if="hasRight('SCHEDULE_WRITE')"
        v-bind="$config.buttonAttrs.floating"
        :to="{ name: 'NewDateInterval' }"
        title="Hozzáadás"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>

    <h1 class="py-6">Időszakok</h1>

    <v-expansion-panels class="mb-4" :mandatory="!!Object.values(search).find((e) => e !== '')">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card :loading="loading">
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
      >
        <template #[`item.d`]="{ item }"
          >{{ item.start_date | moment('ll') }} - {{ item.end_date | moment('ll') }}</template
        >
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('SCHEDULE_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm ma-1"
            :to="{ name: 'DateIntervalEditor', params: { id: item.id } }"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('SCHEDULE_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm ma-1"
            @click="deleteDateInterval(item)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'DateIntervalList',
      fetchItems: this.fetchDateIntervals,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Időszak', value: 'd', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
      },
      searchTimeout: null,
    };
  },

  methods: {
    parseSearchQueries() {
      return {
        license_plate_number: this.$route.query.license_plate_number,
        rf_id_code: this.$route.query.rf_id_code,
      };
    },

    async deleteDateInterval(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> időszak törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          await this.$http.get(
            "date-intervals/delete/" + item.id
          );
          this.fetchDateIntervals();
          this.$dialog.notify.info('Az időszak törölve!');
        } catch (e) {
          console.error(e);
        }
      }
    },

    async fetchDateIntervals() {
      this.loading = true;
      try {
        const data = JSON.parse(JSON.stringify(this.search));
        data.sort_by = this.options.sortBy || [""];
        data.sort_desc = this.options.sortDesc || [false];
        const response = await this.$http.post("date-intervals/list", this.options);
        this.dataTable.items = response.date_intervals;
        this.dataTable.itemsLength = response.date_intervals_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
      };
    }
  }
};
</script>
